module.exports = __webpack_public_path__ + "media/images/projects/7-dashboard-00289506a4e2f5b0258fbc07c7efa3ed.jpg";